import React from "react"

import { RenderIf } from "../helpers/RenderIf";
import { T } from "../traks";

const FileIcon = ({ fileType }) => {
	let src = ""
	if (fileType.includes("pdf"))
		src = "https://static.sibilus.eu/gfx/PDF-icon-0.svg";
	else if (fileType.includes("png"))
		src = "https://static.sibilus.eu/gfx/PNG-icon-0.svg";
	else if (fileType.includes("doc"))
		src = "https://static.sibilus.eu/gfx/doc-icon-0.svg";
	else if (fileType.includes("docx"))
		src = "https://static.sibilus.eu/gfx/DOCX-icon-0.svg";
	else if (fileType.includes("jpg") || fileType.includes("jpeg"))
		src = "https://static.sibilus.eu/gfx/JPG-icon-0.svg";
	else if (fileType.includes("mp3") || fileType.includes("mpeg"))
		src = "https://static.sibilus.eu/gfx/mp3-icon-0.svg";
	else if (fileType.includes("mp4") || fileType.includes("mpeg4"))
		src = "https://static.sibilus.eu/gfx/mp4-icon-0.svg";
	else if (fileType.includes("text") || fileType.includes("txt"))
		src = "https://static.sibilus.eu/gfx/txt-icon-0.svg";
	else if (fileType.includes("wav"))
		src = "https://static.sibilus.eu/gfx/wav-icon-0.svg";
	else
		src = "https://static.sibilus.eu/gfx/file-icon-0.svg";

	return <img src={src} alt="file-icon" className="me-3" style={{width: "36px"}} />
}

const shortenName = (name) => {
	name = name.split(".")[0]
	if(name.includes("audioContent")){
		return "audioEntry"
	}
	return name
}

const Documents = ({ files, downloadFile, removeFile, screenName }) => {
	return (
		<RenderIf condition={files.length > 0}>
			<div className="mb-5">
				<div className="mb-2">
					<T>Documents</T>:
				</div>
				<div>
					<RenderIf condition={files.length > 0}>
						{files.map((f, index) =>
							<div className="sibilus_border border_radius_6px py-3 px-3 d-flex flex-row flex-wrap justify-content-between align-items-center my-1" key={"d"+index}>
								<div className="d-flex flex-row">
									<FileIcon fileType={f.type} />
									<div className="d-flex flex-column">
										<div className="fw_600">{shortenName(f.name)}</div>
										<div>{f.name.split(".")[1]}<T> file</T></div>
									</div>
								</div>
								<FileActions
									file={f}
									removeFile={removeFile}
									downloadFile={downloadFile}
									screenName={screenName}
								/>
							</div>
						)}
					</RenderIf>
				</div>
			</div>
		</RenderIf>
	)
}


const Images = ({ files, removeFile, downloadFile, screenName }) => {
	return (
		<RenderIf condition={files.length > 0}>
			<div className="mb-2">
				<T>Images</T>:
			</div>
			<div>
				<RenderIf condition={files.length > 0}>
					{files.map((f, index) =>
						<div className="sibilus_border border_radius_6px py-3 px-3 d-flex flex-row justify-content-between align-items-center my-1" key={"i"+index}>
							<div className="d-flex flex-row">
								<FileIcon fileType={f.type} />
								<div className="d-flex flex-column">
									<div className="fw_600">{shortenName(f.name)}</div>
									<div>{f.name.split(".")[1]}<T> file</T></div>
								</div>
							</div>
							<FileActions
								file={f}
								removeFile={removeFile}
								downloadFile={downloadFile}
								screenName={screenName}
							/>
						</div>
					)}
				</RenderIf>
			</div>
		</RenderIf>
	)
}

const FileActions = ({ file, removeFile, downloadFile, screenName }) => {
	return (
		<div className="d-flex flex-row">
			<RenderIf condition={file.screen_name === screenName}>
				<div onClick={() => removeFile(file)} className="cursor_pointer btn">
					<img src="https://static.sibilus.eu/gfx/bin-icon-0.svg" alt="bin-icon" style={{width: "20px"}} />
				</div>
			</RenderIf>
			<div onClick={() => downloadFile(file)} className="cursor_pointer btn">
				<img src="https://static.sibilus.eu/gfx/download-icon-0.svg" alt="download-icon" style={{width: "20px"}} />
			</div>
		</div>

	)
}

const MediaFiles = ({ files, removeFile, downloadFile, screenName }) => {
	return (
		<RenderIf condition={files.length > 0}>
			<div className="mb-5">

				<div className="mb-2">
					<T>Media files</T>:
				</div>
				<div>
					<RenderIf condition={files.length > 0}>
						{files.map((f, index) =>
							<div className="sibilus_border border_radius_6px py-3 px-3 d-flex flex-row justify-content-between align-items-center my-1" key={"d"+index}>
								<div className="d-flex flex-row">
									<FileIcon fileType={f.type} />
									<div className="d-flex flex-column">
										<div className="fw_600">{shortenName(f.name)}</div>
										<div>{f.name.split(".")[1]}<T> file</T></div>
									</div>
								</div>
								<FileActions
									file={f}
									removeFile={removeFile}
									downloadFile={downloadFile}
									screenName={screenName}
								/>
							</div>
						)}
					</RenderIf>
				</div>
			</div>
		</RenderIf>
	)
}

const OtherFiles = ({ files, removeFile, downloadFile, screenName }) => {
	return (
		<RenderIf condition={files.length > 0}>
			<div className="mb-2">
				<T>Other files</T>:
			</div>
			<div>
				<RenderIf condition={files.length > 0}>
					{files.map((f, index) =>
						<div className="sibilus_border border_radius_6px py-3 px-3 d-flex flex-row justify-content-between align-items-center my-1" key={"o"+index}>
							<div className="d-flex flex-row">
								<FileIcon fileType={f.type} />
								<div className="d-flex flex-column">
									<div className="fw_600">{f.name.split(".")[0]}</div>
									<div>{f.name.split(".")[1]}<T> file</T></div>
								</div>
							</div>
							<FileActions
								file={f}
								removeFile={removeFile}
								downloadFile={downloadFile}
								screenName={screenName}
							/>
						</div>
					)}
				</RenderIf>
			</div>
		</RenderIf>
	)
}

export const DownloadFiles = ({ files, removeFile, downloadFile, screenName }) => {
	const mediaFiles = files.filter(file => file.type.includes("audio") || file.type.includes("video"))
	const images = files.filter(file => file.type.includes("nothere"))
	const documents = files.filter(file => file.type.includes("text") || file.type.includes("application"))
	const otherFiles = files.filter(file => !mediaFiles.includes(file) && !images.includes(file) && !documents.includes(file))

	return (
		<div className="d-flex flex-column">
			<Documents files={documents} downloadFile={downloadFile} removeFile={removeFile} screenName={screenName} />
			<MediaFiles files={mediaFiles} downloadFile={downloadFile} removeFile={removeFile} screenName={screenName} />
			<Images files={images} downloadFile={downloadFile} removeFile={removeFile} screenName={screenName} />
			<OtherFiles files={otherFiles} downloadFile={downloadFile} removeFile={removeFile} screenName={screenName} />
		</div >
	)
}
